import { Combobox, Expander, type ComboOption } from "../../../design/components";
import styles from "./mapping.module.css";
import type { TransformDto } from "./types";

export type TransformChange = { transform: string; args: Record<string, unknown> };

function asText(value: unknown): string {
  if (value === null || value === undefined) return "";
  return typeof value === "string" ? value : JSON.stringify(value);
}

export function TransformPicker({
  id,
  label,
  transform,
  args,
  transforms,
  disabled,
  onChange,
}: {
  id: string;
  label: string;
  transform: string;
  args: Record<string, unknown>;
  transforms: TransformDto[];
  disabled?: boolean | undefined;
  onChange(change: TransformChange): void;
}) {
  const chosen = transforms.find((item) => item.name === transform);
  const options: ComboOption[] = transforms.map((item) => ({
    v: item.name,
    n: item.name,
    d: `${item.title} — ${item.description}`,
  }));

  return (
    <div className={styles.transform}>
      <Combobox
        id={id}
        ariaLabel={label}
        value={transform}
        options={options}
        placeholder="transform…"
        disabled={disabled}
        onPick={(name) => onChange({ transform: name, args: {} })}
      />
      {chosen?.args
        .filter((arg) => arg.required)
        .map((arg) => (
          <label key={arg.name} className={styles.argRow}>
            <span className={styles.argName}>{arg.name}</span>
            <input
              key={`${transform}-${arg.name}-${asText(args[arg.name])}`}
              type="text"
              aria-label={arg.name}
              defaultValue={asText(args[arg.name])}
              disabled={disabled}
              onBlur={(event) => onChange({ transform, args: { ...args, [arg.name]: event.target.value } })}
            />
          </label>
        ))}
      <Expander
        head="All arguments as JSON"
        body={
          <textarea
            key={JSON.stringify(args)}
            aria-label="All arguments as JSON"
            className={styles.argJson}
            defaultValue={JSON.stringify(args)}
            disabled={disabled}
            onBlur={(event) => {
              try {
                onChange({ transform, args: JSON.parse(event.target.value) as Record<string, unknown> });
              } catch {
                /* invalid JSON: keep editing */
              }
            }}
          />
        }
      />
    </div>
  );
}
